import { useState } from "react";
import { KeyRound } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Field } from "@/components/PageHeader";

export const ChangePasswordDialog = ({ open, onClose }) => {
  const [f, setF] = useState({ current: "", next: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const submit = async () => {
    if (f.next !== f.confirm) return toast.error("La confirmation ne correspond pas");
    setBusy(true);
    try { await api.post("/auth/change-password", { current_password: f.current, new_password: f.next }); toast.success("Mot de passe modifié"); setF({ current: "", next: "", confirm: "" }); onClose(); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent data-testid="password-dialog">
        <DialogHeader><DialogTitle className="font-display flex items-center gap-2"><KeyRound size={18} /> Changer mon mot de passe</DialogTitle></DialogHeader>
        <Field label="Mot de passe actuel"><Input type="password" value={f.current} onChange={(e) => setF({ ...f, current: e.target.value })} data-testid="pwd-current" /></Field>
        <Field label="Nouveau mot de passe"><Input type="password" value={f.next} onChange={(e) => setF({ ...f, next: e.target.value })} data-testid="pwd-new" /></Field>
        <Field label="Confirmer le nouveau mot de passe"><Input type="password" value={f.confirm} onChange={(e) => setF({ ...f, confirm: e.target.value })} data-testid="pwd-confirm" /></Field>
        <div className="flex gap-2"><Button variant="outline" className="flex-1" onClick={onClose} data-testid="pwd-cancel">Annuler</Button><Button className="flex-1 bg-[#059669] hover:bg-[#047857]" disabled={busy || !f.current || f.next.length < 4} onClick={submit} data-testid="pwd-submit">Valider</Button></div>
      </DialogContent>
    </Dialog>
  );
};
